module.exports = __webpack_public_path__ + "img/circle-red.fd428461.svg";